import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26aae60d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "cps-detail-wysiwyg" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown dropdown-page-data"
}
const _hoisted_3 = {
  class: "btn btn-hover icon-link dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_8 = {
  key: 3,
  class: "dropdown dropdown-status"
}
const _hoisted_9 = {
  class: "btn btn-hover icon-link dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = { class: "mas fw-light" }
const _hoisted_11 = { class: "dropdown-menu" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "open_in_new", -1))
const _hoisted_16 = {
  key: 6,
  class: "dropdown dropdown-status"
}
const _hoisted_17 = {
  class: "btn btn-hover icon-link dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "sell", -1))
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "refresh", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "create-homepage mt-3"
}
const _hoisted_26 = {
  key: 2,
  class: "create-namedpage mt-3"
}
const _hoisted_27 = {
  key: 3,
  class: "content mt-3"
}
const _hoisted_28 = { class: "col-11 row-content" }
const _hoisted_29 = { class: "row gx-2" }
const _hoisted_30 = { class: "col-auto" }
const _hoisted_31 = { class: "cp-row-background d-flex flex-column h-100" }
const _hoisted_32 = ["data-dp-tooltip"]
const _hoisted_33 = { class: "col" }
const _hoisted_34 = ["id"]
const _hoisted_35 = { class: "row gx-2" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "cp-row-content d-flex align-items-center" }
const _hoisted_38 = ["data-row-id", "data-column-id"]
const _hoisted_39 = ["onClick", "data-dp-tooltip"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "col-1 row-edit d-flex align-items-center" }
const _hoisted_43 = { class: "row-controls d-flex flex-column justify-content-center align-items-center" }
const _hoisted_44 = ["onClick", "data-dp-tooltip"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "keyboard_arrow_up", -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["onClick", "id"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "pending", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["onClick", "data-dp-tooltip"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "keyboard_arrow_down", -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { class: "ms-2" }
const _hoisted_54 = { class: "row py-4" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "d-flex justify-content-center" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light me-2" }, "add_circle", -1))
const _hoisted_58 = { class: "d-flex flex-column justify-content-between h-100" }
const _hoisted_59 = { class: "buttons d-flex flex-column" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "check_box_outline_blank", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "content_paste", -1))
const _hoisted_62 = { class: "d-flex justify-content-end pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_63 = { class: "d-flex flex-column justify-content-between h-100" }
const _hoisted_64 = { class: "d-flex justify-content-end pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_65 = { class: "d-none" }
const _hoisted_66 = {
  class: "wysiwyg-popover-content",
  ref: "editRowPopoverContent"
}
const _hoisted_67 = ["data-dp-tooltip"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "visibility", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_74 = ["data-dp-tooltip"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "keyboard_double_arrow_up", -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = ["data-dp-tooltip"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "keyboard_double_arrow_down", -1))
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_81 = ["data-dp-tooltip"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1))
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = ["data-dp-tooltip"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_paste_go", -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_88 = ["data-dp-tooltip"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_92 = ["data-dp-tooltip"]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "close", -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = {
  class: "wysiwyg-popover-content",
  ref: "editColumnPopoverContent"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "visibility", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_99 = ["data-dp-tooltip"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "arrow_back", -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = ["data-dp-tooltip"]
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "arrow_forward", -1))
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_106 = ["data-dp-tooltip"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "content_copy", -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_110 = ["data-dp-tooltip"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, null, -1))
const _hoisted_114 = ["data-dp-tooltip"]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "close", -1))
const _hoisted_116 = [
  _hoisted_115
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MetadataIcons = _resolveComponent("MetadataIcons")!
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_ContentPageColumn = _resolveComponent("ContentPageColumn")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_ContentPagePageSettings = _resolveComponent("ContentPagePageSettings")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!
  const _component_SnippetMetaData = _resolveComponent("SnippetMetaData")!
  const _component_ContentPagePageAbstract = _resolveComponent("ContentPagePageAbstract")!
  const _component_ContentPageRowDetail = _resolveComponent("ContentPageRowDetail")!
  const _component_ContentPageRowVisibilityRule = _resolveComponent("ContentPageRowVisibilityRule")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_ContentPageColumnDetail = _resolveComponent("ContentPageColumnDetail")!
  const _component_ContentPageColumnVisibilityRule = _resolveComponent("ContentPageColumnVisibilityRule")!
  const _component_ContentPageAddColumn = _resolveComponent("ContentPageAddColumn")!
  const _component_ContentPageCopy = _resolveComponent("ContentPageCopy")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseTitle, {
      title: _ctx.title,
      "back-route": _ctx.returnRoute,
      "help-text": _ctx.$t('descriptions.contentPagesDetailEdit'),
      mb: 5
    }, _createSlots({
      buttons: _withCtx(() => [
        (!_ctx.isHomepage && !_ctx.isNamedPage && _ctx.backRoute !== 'snippets' && _ctx.backRoute !== 'popup-detail')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('cms.pageInformation')), 1)
              ]),
              _createElementVNode("ul", _hoisted_5, [
                _createElementVNode("li", null, [
                  _createVNode(_component_base_offcanvas_button_open, {
                    "offcanvas-id": "offcanvas-edit-page-settings",
                    class: "dropdown-item",
                    onClick: _withModifiers(_ctx.openPageSettings, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cms.generalInformation')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_base_offcanvas_button_open, {
                    "offcanvas-id": "offcanvas-edit-page-abstract",
                    class: "dropdown-item",
                    onClick: _withModifiers(_ctx.openPageAbstract, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cms.overviewPageContent')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.backRoute === 'snippets')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_base_offcanvas_button_open, {
                "offcanvas-id": "offcanvas-edit-snippet-settings",
                class: "btn btn-hover icon-link",
                onClick: _withModifiers(_ctx.openSnippetSettings, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('context')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.isHomepage && _ctx.hasHomepage) || (_ctx.isNamedPage && _ctx.hasNamedPage))
          ? (_openBlock(), _createBlock(_component_base_offcanvas_button_open, {
              key: 2,
              "offcanvas-id": "offcanvas-edit-page-abstract",
              onClick: _withModifiers(_ctx.openPageAbstract, ["prevent"]),
              class: "btn btn-hover icon-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cms.overviewPageContent')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isReady && !_ctx.isHomepage && !_ctx.isNamedPage && _ctx.backRoute !== 'popup-detail')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, [
                _createElementVNode("i", _hoisted_10, _toDisplayString((_ctx.contentPage.cp.status_code === _ctx.StatusEnum.PUBLISHED) ? 'visibility' : 'visibility_off'), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.enumContentStatus.find(
                (contentStatus) => contentStatus.code === _ctx.contentPage.cp.status_code
              ).description), 1)
              ]),
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumContentStatus, (contentStatus) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: contentStatus.code
                  }, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.setStatusCode(contentStatus.code)), ["prevent"]),
                      class: "dropdown-item",
                      type: "button"
                    }, _toDisplayString(contentStatus.description), 9, _hoisted_12)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode === _ctx.PageDetailModeEnum.EDIT && (!_ctx.isHomepage || (_ctx.isHomepage && _ctx.hasHomepage)) && (!_ctx.isNamedPage || (_ctx.isNamedPage && _ctx.hasNamedPage)) && (_ctx.getCustomers?.length > 1) && _ctx.backRoute !== 'popup-detail')
          ? (_openBlock(), _createBlock(_component_base_modal_button, {
              key: 4,
              class: "btn btn-hover icon-link",
              "modal-id": "copy-content-page-modal"
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('copyTo')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isReady && (!_ctx.isHomepage || (_ctx.isHomepage && _ctx.hasHomepage)) && (!_ctx.isNamedPage || (_ctx.isNamedPage && _ctx.hasNamedPage)))
          ? (_openBlock(), _createElementBlock("a", {
              key: 5,
              href: _ctx.previewUrl,
              target: "_blank",
              class: "btn btn-hover icon-link"
            }, [
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.$t('preview')), 1)
            ], 8, _hoisted_14))
          : _createCommentVNode("", true),
        (_ctx.isReady && _ctx.isPriceCardPage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("button", _hoisted_17, [
                _hoisted_18,
                _createTextVNode(_toDisplayString(_ctx.$t('priceCard')), 1)
              ]),
              _createElementVNode("ul", _hoisted_19, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.priceCardPreviewUrl('A4'),
                    target: "_blank",
                    class: "dropdown-item"
                  }, "A4", 8, _hoisted_20)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.priceCardPreviewUrl('A5'),
                    target: "_blank",
                    class: "dropdown-item"
                  }, "A5", 8, _hoisted_21)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.priceCardPreviewUrl('A6'),
                    target: "_blank",
                    class: "dropdown-item"
                  }, "A6", 8, _hoisted_22)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args))),
          class: "btn btn-hover icon-link"
        }, _hoisted_24)
      ]),
      _: 2
    }, [
      (_ctx.isReady)
        ? {
            name: "icons",
            fn: _withCtx(() => [
              _createVNode(_component_MetadataIcons, {
                "custom-design-template": _ctx.contentPage?.cd_template,
                "page-element-metadata": _ctx.contentPage?.element_metadata
              }, null, 8, ["custom-design-template", "page-element-metadata"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "back-route", "help-text"]),
    _createVNode(_component_alert_error, {
      exceptions: _ctx.exceptions,
      class: "mt-3"
    }, null, 8, ["exceptions"]),
    (!_ctx.isReady)
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isReady && (_ctx.isHomepage && !_ctx.hasHomepage))
      ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createHomepagePressed && _ctx.createHomepagePressed(...args))),
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.$t('create')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isReady && (_ctx.isNamedPage && !_ctx.hasNamedPage))
      ? (_openBlock(), _createElementBlock("section", _hoisted_26, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createNamedPagePressed && _ctx.createNamedPagePressed(...args))),
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.$t('create')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isReady && (!_ctx.isHomepage || (_ctx.isHomepage && _ctx.hasHomepage)) && (!_ctx.isNamedPage || (_ctx.isNamedPage && _ctx.hasNamedPage)))
      ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentPage.rows, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row.id,
              class: "row gx-3 align-items-center"
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      (row.row.margin_top_code !== 'M_0')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["d-flex", _ctx.getHeightable(row.row.margin_top_code)])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["bg-color-container d-flex flex-grow-1 justify-content-center align-items-center", _ctx.getBackgroundClasses(row.row.background_color_code, row.row.background_color)]),
                        style: _normalizeStyle(_ctx.getBackgroundStyle(row.row.background_color))
                      }, [
                        (row?.element_metadata?.visibility_rule_id)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: "mas fw-light fs-6",
                              "data-dp-tooltip": _ctx.getDescriptionVisibilityRuleStatus(row.element_metadata)
                            }, _toDisplayString((row?.element_metadata?.status.code === _ctx.StatusEnum.PUBLISHED) ? 'visibility' : 'visibility_off'), 9, _hoisted_32))
                          : _createCommentVNode("", true)
                      ], 6),
                      (row.row.margin_bottom_code !== 'M_0')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(_ctx.getHeightable(row.row.margin_bottom_code))
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", {
                      class: "cp-row",
                      id: 'row-' + row.id
                    }, [
                      (row.row.margin_top_code !== 'M_0')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["cp-row-margin", _ctx.getHeightable(row.row.margin_top_code)])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          (row.row.padding_top_code !== 'P_0')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["cp-row-padding", _ctx.getHeightable(row.row.padding_top_code)])
                              }, null, 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_Container, {
                              onDrop: _ctx.onDrop,
                              orientation: "horizontal",
                              "lock-axis": "x",
                              "drag-handle-selector": ".drag-handle",
                              class: _normalizeClass([_ctx.getRowClasses(row.row), "w-100"])
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.columns, (column) => {
                                  return (_openBlock(), _createBlock(_component_Draggable, {
                                    key: column.id,
                                    class: _normalizeClass(_ctx.getColumnWidthCode(column.cb_in_row.column_width_code))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        "data-row-id": row.id,
                                        "data-column-id": column.id
                                      }, [
                                        _createVNode(_component_ContentPageColumn, {
                                          column: column,
                                          "row-id": row.id,
                                          "active-column-id": _ctx.activeColumnId,
                                          "is-invisible-row": row?.element_metadata?.status.code === _ctx.StatusEnum.NOT_PUBLISHED,
                                          onActivateColumn: _ctx.activateColumn
                                        }, null, 8, ["column", "row-id", "active-column-id", "is-invisible-row", "onActivateColumn"])
                                      ], 8, _hoisted_38)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["onDrop", "class"]),
                            _createElementVNode("button", {
                              onClick: _withModifiers(($event: any) => (_ctx.openAddColumnFromRow(row.id)), ["prevent"]),
                              class: "btn btn-link text-reset py-0 px-1",
                              "data-dp-tooltip": _ctx.$t('cms.addColumn')
                            }, _hoisted_41, 8, _hoisted_39)
                          ]),
                          (row.row.padding_bottom_code !== 'P_0')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["cp-row-padding", _ctx.getHeightable(row.row.padding_bottom_code)])
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (row.row.margin_bottom_code !== 'M_0')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["cp-row-margin", _ctx.getHeightable(row.row.margin_bottom_code)])
                          }, null, 2))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_34)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.moveRow(_ctx.MoveActionEnum.UP, row.id)), ["prevent"]),
                    "data-dp-tooltip": _ctx.$t('moveUp'),
                    class: "btn btn-link p-0"
                  }, _hoisted_46, 8, _hoisted_44),
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.activateRow(row.id)), ["prevent"]),
                    id: 'edit-row-' + row.id,
                    class: "btn btn-link p-0"
                  }, _hoisted_49, 8, _hoisted_47),
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.moveRow(_ctx.MoveActionEnum.DOWN, row.id)), ["prevent"]),
                    "data-dp-tooltip": _ctx.$t('moveDown'),
                    class: "btn btn-link p-0"
                  }, _hoisted_52, 8, _hoisted_50)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_MetadataIcons, {
                    "custom-design-template": row?.cd_template,
                    "page-element-metadata": row?.element_metadata,
                    "has-eyebrow": !!(row?.row?.eyebrow),
                    "has-overlays": !!(row?.row?.background_image?.overlays?.length)
                  }, null, 8, ["custom-design-template", "page-element-metadata", "has-eyebrow", "has-overlays"])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_base_offcanvas_button_open, {
                  "offcanvas-id": "offcanvas-add-row",
                  class: "btn btn-icon text-reset text-decoration-none fs-5"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cms.addRow')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.backRoute !== 'snippets' && _ctx.backRoute !== 'popup-detail')
      ? (_openBlock(), _createBlock(_component_base_offcanvas, {
          key: 4,
          title: _ctx.$t('cms.editPageInformation'),
          id: "offcanvas-edit-page-settings",
          label: "offcanvasEditPageSettings",
          class: "offcanvas-wide"
        }, {
          default: _withCtx(() => [
            (_ctx.isReady)
              ? (_openBlock(), _createBlock(_component_ContentPagePageSettings, {
                  key: 0,
                  ref: "pageSettings",
                  "page-type": _ctx.pageType,
                  "content-page": _ctx.contentPage,
                  onSaved: _ctx.reloadContent
                }, null, 8, ["page-type", "content-page", "onSaved"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.backRoute === 'snippets')
      ? (_openBlock(), _createBlock(_component_base_offcanvas, {
          key: 5,
          title: _ctx.$t('editSnippetInfo'),
          id: "offcanvas-edit-snippet-settings",
          label: "offcanvasEditSnippetSettings",
          class: "offcanvas-wide"
        }, {
          default: _withCtx(() => [
            (_ctx.isReady)
              ? (_openBlock(), _createBlock(_component_SnippetMetaData, {
                  key: 0,
                  ref: "snippetMetaData",
                  id: _ctx.$route.params.snippetId,
                  mode: _ctx.PageDetailModeEnum.EDIT
                }, null, 8, ["id", "mode"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('cms.editOverviewPageContent'),
      id: "offcanvas-edit-page-abstract",
      label: "offcanvasEditPageAbstract",
      class: "offcanvas-wide"
    }, {
      default: _withCtx(() => [
        (_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_ContentPagePageAbstract, {
              key: 0,
              ref: "pageAbstract",
              "content-page": _ctx.contentPage,
              onSaved: _ctx.reloadContent
            }, null, 8, ["content-page", "onSaved"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('cms.editRow'),
      id: "offcanvas-edit-row",
      label: "offcanvasEditRow",
      class: "offcanvas-wide"
    }, {
      default: _withCtx(() => [
        (_ctx.activeRowId)
          ? (_openBlock(), _createBlock(_component_ContentPageRowDetail, {
              key: 0,
              ref: "rowDetail",
              "page-id": _ctx.contentPage.id,
              "row-id": _ctx.activeRowId,
              "content-id": _ctx.activeRowContentId,
              onSaved: _ctx.reloadContent
            }, null, 8, ["page-id", "row-id", "content-id", "onSaved"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('cms.editRowVisibilityRule'),
      id: "offcanvas-edit-row-visibility-rule",
      label: "offcanvasEditRowVisibilityRule",
      class: "offcanvas-wider"
    }, {
      default: _withCtx(() => [
        (_ctx.activeRowId)
          ? (_openBlock(), _createBlock(_component_ContentPageRowVisibilityRule, {
              key: 0,
              ref: "rowVisibilityRule",
              "page-id": _ctx.contentPage.id,
              "row-id": _ctx.activeRowId,
              onSaved: _ctx.reloadContent
            }, null, 8, ["page-id", "row-id", "onSaved"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('cms.addRow'),
      id: "offcanvas-add-row",
      label: "offcanvasAddRow"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_base_offcanvas_button_close, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addRow(_ctx.enums.predefinedContentPageRowEnum.EMPTY))),
              class: "btn btn-icon btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_60,
                _createTextVNode(_toDisplayString(_ctx.$t('cms.emptyRow')), 1)
              ]),
              _: 1
            }),
            (_ctx.contentPageRowClipboard.rowId)
              ? (_openBlock(), _createBlock(_component_base_offcanvas_button_close, {
                  key: 0,
                  onClick: _ctx.pasteRow,
                  class: "btn btn-icon btn-primary mt-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_61,
                    _createTextVNode(_toDisplayString(_ctx.$t('cms.pasteRowFromClipboard')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(_component_base_offcanvas_button_close, { class: "btn btn-light" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_base_offcanvas, {
      id: "offcanvas-edit-column",
      label: "offcanvasEditColumn",
      class: "offcanvas-wide",
      "custom-content": true
    }, {
      default: _withCtx(() => [
        (_ctx.activeColumnId && _ctx.activeColumnRowId)
          ? (_openBlock(), _createBlock(_component_ContentPageColumnDetail, {
              key: 0,
              ref: "columnDetail",
              id: _ctx.activeColumnId,
              "row-id": _ctx.activeColumnRowId,
              "page-id": _ctx.contentPage.id,
              "content-id": _ctx.activeColumnContentId,
              "is-homepage": _ctx.isHomepage,
              "is-named-page": _ctx.isNamedPage,
              onSaved: _ctx.reloadContent
            }, null, 8, ["id", "row-id", "page-id", "content-id", "is-homepage", "is-named-page", "onSaved"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('cms.editColumnVisibilityRule'),
      id: "offcanvas-edit-column-visibility-rule",
      label: "offcanvasEditColumnVisibilityRule",
      class: "offcanvas-wider"
    }, {
      default: _withCtx(() => [
        (_ctx.activeColumnRowId && _ctx.activeColumnId)
          ? (_openBlock(), _createBlock(_component_ContentPageColumnVisibilityRule, {
              key: 0,
              ref: "columnVisibilityRule",
              "row-id": _ctx.activeColumnRowId,
              "cb-in-row-id": _ctx.activeColumnId,
              onSaved: _ctx.reloadContent
            }, null, 8, ["row-id", "cb-in-row-id", "onSaved"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_base_offcanvas, {
      title: _ctx.$t('cms.addColumn'),
      id: "offcanvas-add-column",
      label: "offcanvasAddColumn"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_63, [
          (_ctx.activeRowId)
            ? (_openBlock(), _createBlock(_component_ContentPageAddColumn, {
                key: 0,
                ref: "addColumn",
                "row-id": _ctx.activeRowId,
                onSubmit: _ctx.onContentPageAddColumnSubmit
              }, null, 8, ["row-id", "onSubmit"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_base_offcanvas_button_close, { class: "btn btn-light" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    (_ctx.backRoute !== 'popup-detail')
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 6,
          title: _ctx.$t('copyTo'),
          "modal-id": "copy-content-page-modal",
          "no-footer": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentPageCopy, {
              "page-id": _ctx.id,
              "page-type-code": _ctx.copyPageTypeCode,
              "back-route": _ctx.backRoute
            }, null, 8, ["page-id", "page-type-code", "back-route"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAddColumn && _ctx.openAddColumn(...args)), ["prevent"])),
          class: "btn btn-link text-success",
          "data-dp-tooltip": _ctx.$t('cms.addColumn')
        }, _hoisted_69, 8, _hoisted_67),
        _hoisted_70,
        _createVNode(_component_base_offcanvas_button_open, {
          onClick: _withModifiers(_ctx.openEditRow, ["prevent"]),
          "offcanvas-id": "offcanvas-edit-row",
          class: "btn btn-link text-warning",
          "data-dp-tooltip": _ctx.$t('cms.editRow')
        }, {
          default: _withCtx(() => [
            _hoisted_71
          ]),
          _: 1
        }, 8, ["onClick", "data-dp-tooltip"]),
        _createVNode(_component_base_offcanvas_button_open, {
          onClick: _withModifiers(_ctx.openEditRowVisibilityRule, ["prevent"]),
          "offcanvas-id": "offcanvas-edit-row-visibility-rule",
          class: "btn btn-link text-warning",
          "data-dp-tooltip": _ctx.$t('cms.editRowVisibilityRule')
        }, {
          default: _withCtx(() => [
            _hoisted_72
          ]),
          _: 1
        }, 8, ["onClick", "data-dp-tooltip"]),
        _hoisted_73,
        _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.moveRow(_ctx.MoveActionEnum.TOP)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('moveToTop')
        }, _hoisted_76, 8, _hoisted_74),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.moveRow(_ctx.MoveActionEnum.BOTTOM)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('moveToBottom')
        }, _hoisted_79, 8, _hoisted_77),
        _hoisted_80,
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.duplicateRow && _ctx.duplicateRow(...args)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('cms.duplicateRow')
        }, _hoisted_83, 8, _hoisted_81),
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyRow && _ctx.copyRow(...args)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('cms.copyRowToClipboard')
        }, _hoisted_86, 8, _hoisted_84),
        _hoisted_87,
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmDeleteRow && _ctx.confirmDeleteRow(...args)), ["prevent"])),
          class: "btn btn-link text-danger",
          "data-dp-tooltip": _ctx.$t('cms.deleteRow')
        }, _hoisted_90, 8, _hoisted_88),
        _hoisted_91,
        _createElementVNode("button", {
          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.editRowPopover?.hide()), ["prevent"])),
          class: "btn btn-link text-muted",
          "data-dp-tooltip": _ctx.$t('close')
        }, _hoisted_94, 8, _hoisted_92)
      ], 512),
      _createElementVNode("div", _hoisted_95, [
        _createVNode(_component_base_offcanvas_button_open, {
          onClick: _withModifiers(_ctx.openEditColumn, ["prevent"]),
          "offcanvas-id": "offcanvas-edit-column",
          class: "btn btn-link text-warning",
          "data-dp-tooltip": _ctx.$t('cms.editColumn')
        }, {
          default: _withCtx(() => [
            _hoisted_96
          ]),
          _: 1
        }, 8, ["onClick", "data-dp-tooltip"]),
        _createVNode(_component_base_offcanvas_button_open, {
          onClick: _withModifiers(_ctx.openEditColumnVisibilityRule, ["prevent"]),
          "offcanvas-id": "offcanvas-edit-column-visibility-rule",
          class: "btn btn-link text-warning",
          "data-dp-tooltip": _ctx.$t('cms.editColumnVisibilityRule')
        }, {
          default: _withCtx(() => [
            _hoisted_97
          ]),
          _: 1
        }, 8, ["onClick", "data-dp-tooltip"]),
        _hoisted_98,
        _createElementVNode("button", {
          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.moveColumn(_ctx.MoveActionEnum.UP)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('cms.moveColumnForwards')
        }, _hoisted_101, 8, _hoisted_99),
        _createElementVNode("button", {
          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.moveColumn(_ctx.MoveActionEnum.DOWN)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('cms.moveColumnBackwards')
        }, _hoisted_104, 8, _hoisted_102),
        _hoisted_105,
        _createElementVNode("button", {
          onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.duplicateColumn && _ctx.duplicateColumn(...args)), ["prevent"])),
          class: "btn btn-link",
          "data-dp-tooltip": _ctx.$t('cms.duplicateColumn')
        }, _hoisted_108, 8, _hoisted_106),
        _hoisted_109,
        _createElementVNode("button", {
          onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmDeleteColumn && _ctx.confirmDeleteColumn(...args)), ["prevent"])),
          class: "btn btn-link text-danger",
          "data-dp-tooltip": _ctx.$t('cms.deleteColumn')
        }, _hoisted_112, 8, _hoisted_110),
        _hoisted_113,
        _createElementVNode("button", {
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.editColumnPopover?.hide()), ["prevent"])),
          class: "btn btn-link text-muted",
          "data-dp-tooltip": _ctx.$t('close')
        }, _hoisted_116, 8, _hoisted_114)
      ], 512)
    ])
  ]))
}